import React from "react"
import { useDispatch } from "react-redux"

import styles from "./index.module.scss"
import services from "../../services"
import Loading from "../../components/Loading/Loading"
import XYCenterAlignedWindow from "../../components/XYCenterAlignedWindow"
import { ReactComponent as DangerSign } from "../../images/icons/danger-sign.svg"
import { useParams, useHistory } from "react-router-dom"
import { paths } from "../../routes/paths"
import { userLogout } from "../../actions/user/userActions"
import { remove } from "../../helpers/localStorage"
import axiosInstance from "../../services/axios"

const AccountSettingsPasswordConfirmPage = () => {
  const [state, setState] = React.useState({
    isLoading: true,
    isExpired: false,
  })

  const params = useParams()
  const history = useHistory()
  const dispatch = useDispatch()

  React.useEffect(() => {
    let timer = null

    if (params.token) {
      services.accountServices
        .confirmPasswordUpdate(params.token)
        .then((response) => {
          setState({
            isLoading: false,
            isExpired: false,
          })
          
          // Force logout: clear all local storage and dispatch logout action
          // Always perform logout after password confirmation for security
          // Clear local storage
          remove("currentUser")
          remove("accessToken")
          
          // Clear axios authorization header
          if (axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers) {
            delete axiosInstance.defaults.headers.common["Authorization"]
            delete axiosInstance.defaults.headers["Authorization"]
          }
          
          // Dispatch logout action to clear Redux state
          dispatch(userLogout())
          
          // Redirect to sign-in after 2 seconds
          timer = setTimeout(() => {
            history.push(paths.login)
          }, 2000)
        })
        .catch(() => {
          setState({
            isLoading: false,
            isExpired: true,
          })
          timer = setTimeout(() => {
            history.push(paths.login)
          }, 4000)
        })
    } else {
      setState({
        isLoading: false,
        isExpired: false,
      })
      timer = setTimeout(() => {
        history.push(paths.login)
      }, 2000)
    }

    return () => timer && clearTimeout(timer)
  }, [history, params.token, dispatch])

  return (
    <div className={styles.pageWrap}>
      {state.isLoading ? (
        <Loading />
      ) : (
        <React.Fragment>
          {state.isExpired ? (
            <XYCenterAlignedWindow>
              <div className={styles.emailConfirmedMsgDanger}>
                <div className={styles.dangerSign}>
                  <DangerSign />
                </div>

                <p>
                  This link has expired.
                  <br />
                  You will be redirected to sign in page in few seconds
                </p>
              </div>
            </XYCenterAlignedWindow>
          ) : (
            <XYCenterAlignedWindow title="Password Updated Successfully">
              <div className={styles.msgDescription}>
                Your password has been updated. You will be redirected to sign in page in few seconds.
              </div>
            </XYCenterAlignedWindow>
          )}
        </React.Fragment>
      )}
    </div>
  )
}

export default AccountSettingsPasswordConfirmPage

